import { gql } from '@apollo/client'
import { format, parseISO } from 'date-fns'
import { Link } from 'gatsby'

export const rapidSessionFragment = gql`
  fragment RapidSessionListFragment on RapidSession {
    id
    startDate
    endDate
    reference
    thirdPartyId
    resultsUserEmails
    kitCount {
      positive
      negative
      other
    }
  }
`
const RapidSessionList = ({ sessions }) => {
  return (
    <table className="table is-bordered is-fullwidth">
      <thead>
        <tr>
          <th>Date</th>
          <th>Third Party ID</th>
          <th>Reference</th>
          <th>Results Users</th>
          <th>Kits</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {sessions.map((session) => {
          const counts = session.kitCount

          return (
            <tr key={session.id}>
              <td>{format(parseISO(session.startDate), 'dd/MM/yyyy')}</td>
              <td>
                <Link to={`/dashboard/third-party/${session.thirdPartyId}`}>{session.thirdPartyId}</Link>
              </td>
              <td>{session.reference}</td>
              <td>{session.resultsUserEmails.join(', ')}</td>
              <td>
                {counts.positive + counts.negative} ({counts.positive} pos, {counts.negative} neg)
              </td>
              <td>
                <Link to={`/dashboard/rapid-testing/rapid-session/${session.id}`}>Details</Link>
                &nbsp;|&nbsp;
                <Link to={`/dashboard/rapid-testing/capture-results?sessionId=${session.id}`}>Capture results</Link>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default RapidSessionList
